// Mirrors libvinnie.constants.PREVALENCE_LEVELS — a scale, not a set, so the
// order is load-bearing: comparisons rank by position, and any list of levels
// should read along the scale rather than alphabetically.
export const PREVALENCE_LEVELS = ["unknown", "low", "moderate", "widespread", "ubiquitous"];

// Most-prevalent first, plus the absence of an assessment. Tables scan from
// the alarming end, and "unassessed" is not a point on the scale — it means
// nobody has asked yet, which is different from a model answering "unknown".
export const LEVEL_COLUMNS = [...PREVALENCE_LEVELS].reverse().concat("unassessed");

// The same colors the .products-badge-<level> rules use, so a number in a
// dense table and a badge elsewhere agree about what "widespread" looks like.
export const LEVEL_COLOR = {
  ubiquitous: "var(--severity-critical)",
  widespread: "var(--severity-high)",
  moderate: "var(--severity-medium)",
  low: "var(--severity-low)",
  unknown: "var(--severity-none)",
  unassessed: "var(--text-muted)",
};

// Ordinal position on the scale; -1 for anything off it. "unknown" ranks
// below "low" — it is an information state, not a quantity — so it never
// wins a comparison against a real assessment.
export function levelRank(level) {
  return PREVALENCE_LEVELS.indexOf(String(level || "").toLowerCase());
}
